import { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import React from 'react';
import HeroSection from "./Hero";
import AboutUs from "./AboutUs";
import Services from "./Services";
import Objectives from "./Objectives";
import ContactSection from "./ContactSection";
import LanguageToggle from "../components/LanguageToggle";
import { useLanguage } from "../contexts/LanguageContext";

const Home: React.FC = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { tString } = useLanguage();

    return (
        <div className="w-screen h-screen text-white flex flex-col justify-between">
            {/* HEADER */}
            <header className="bg-[#2A3342]/90 backdrop-blur-lg shadow-md flex justify-between items-center px-6 py-4 md:px-16 fixed top-0 left-0 w-full z-50">
                <img src="/images/Logo-montelo.png" className="h-14" />

                {/* Mobile menu section */}
                <div className="md:hidden flex items-center gap-4">
                    <LanguageToggle />
                    <button
                        className="text-white"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        {menuOpen ? <HiX size={28} /> : <HiMenu size={28} />}
                    </button>
                </div>

                {/* Desktop navigation */}
                <nav className="hidden md:flex space-x-8 text-sm font-medium items-center">
                    <a href="#start" className="hover:underline text-white transition duration-200">
                        {tString('navigation.home')}
                    </a>
                    <a href="#aboutus" className="hover:underline text-white transition duration-200">
                        {tString('navigation.about')}
                    </a>
                    <a href="#services" className="hover:underline text-white transition duration-200">
                        {tString('navigation.services')}
                    </a>
                    <LanguageToggle />
                    <a
                        href="#contact"
                        className="bg-[#29519F] text-white py-2 px-4 font-bold rounded hover:bg-blue-700 transition duration-200"
                    >
                        {tString('navigation.contact')}
                    </a>
                </nav>

                {/* Mobile dropdown menu */}
                {menuOpen && (
                    <div className="rounded-b-xl absolute top-[88px] right-0 w-full bg-[#2A3342]/90 backdrop-blur-lg shadow-md flex flex-col items-start py-3 md:hidden z-50">
                        <a href="#start" className="text-white hover:underline w-full text-left hover:bg-blue-700">
                            <span className="pl-8 py-2 inline-block">{tString('navigation.home')}</span>
                        </a>
                        <a href="#aboutus" className="text-white hover:underline w-full text-left hover:bg-blue-700">
                            <span className="pl-8 py-2 inline-block">{tString('navigation.about')}</span>
                        </a>
                        <a href="#services" className="text-white hover:underline w-full text-left hover:bg-blue-700">
                            <span className="pl-8 py-2 inline-block">{tString('navigation.services')}</span>
                        </a>
                        <a href="#contact" className="text-white hover:underline w-full text-left hover:bg-blue-700">
                            <span className="pl-8 py-2 inline-block">{tString('navigation.contact')}</span>
                        </a>
                    </div>
                )}

            </header>

            {/* BODY */}
            <main className="bg-[#2A3342] flex flex-col items-center text-center px-16 p-10">
                <HeroSection />

                <AboutUs />

                <Services />

                <Objectives />

                <ContactSection />

            </main >

        </div >
    );
};

export default Home;







